import type { Brand } from '@/types/constants';
import type { Zone } from '@/types/zones/zone';
import { getConfig } from '@/utils/config/config';
import { COOKIES, getCookieValue } from '@/utils/cookies';
import { buildApiUrl, buildUrl } from '@/utils/url/build-url';
import { fetchApi } from './fetcher';

const getHeaders = async () => {
    const config = getConfig();
    const region = await getCookieValue(COOKIES.REGION);
    const brand = process.env.BRAND as Brand;

    const headers = {
        'x-region-code': region,
        'x-brand': brand
    };

    return {
        headers,
        options: {
            networkConfig: config.network.InternalGamesRecommenderClient
        }
    };
};

const getGamesRecommenderBaseUrl = () => {
    const config = getConfig();
    return buildApiUrl(config.apis.GamesRecommenderClient);
};

export const getSimilarGames = async (
    anchorGameUid: string,
    localeKey: string,
    channel: string = 'desktop'
): Promise<Zone | null> => {
    const baseUrl = getGamesRecommenderBaseUrl();
    const { headers, options } = await getHeaders();

    const url = buildUrl(`${baseUrl}/v1/similar-games/recommendations`, {
        gameUid: anchorGameUid,
        localeKey,
        channel,
        product: process.env.PRODUCT as string
    });

    try {
        const res = await fetchApi(
            url,
            {
                method: 'GET',
                headers
            },
            options
        );

        if (!res.ok) return null;

        const json = await res.json();
        return json && json.id ? (json as Zone) : null;
    } catch (e) {
        console.error(`getSimilarGames error: ${(e as Error).message}`);
        return null;
    }
};
